import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { scaffolderTranslationRef } from '@backstage/plugin-scaffolder/alpha';

// The portal is used to request infrastructure, access and tooling from templates, not only to create components.
const scaffolderMessages = createTranslationMessages({
  ref: scaffolderTranslationRef,
  messages: {
    'templateListPage.title': 'Request a new component',
    'templateListPage.pageTitle': 'Request a new component',
    'templateListPage.subtitle':
      'Request infrastructure, access and tooling from the standard templates of the platform',
    'templateListPage.contentHeader.supportButtonTitle':
      'Request infrastructure, access and tooling from standard templates. Each template runs the approval and provisioning steps of its request.',
    'templateWizardPage.title': 'Request a new component',
    'templateWizardPage.pageTitle': 'Request a new component',
    'templateWizardPage.subtitle':
      'Request infrastructure, access and tooling from the standard templates of the platform',
    'templateWizardPage.templateWithTitle': 'Request {{templateTitle}}',
  },
});

export const ScaffolderTranslations = TranslationBlueprint.make({
  name: 'scaffolder-wording',
  params: { resource: scaffolderMessages },
});
